import { Link } from "react-router-dom";
import { CheckCircle2, XCircle, ShieldCheck } from "lucide-react";
import { Panel, Label, HudButton } from "@/components/hud";

export default function CheckoutResult({ status = "success" }) {
  const ok = status === "success";
  const sessionId = ok
    ? new URLSearchParams(window.location.search).get("session_id")
    : null;

  return (
    <div className="max-w-xl mx-auto space-y-6 yb-rise" data-testid={`checkout-${status}`}>
      <Panel className="flex flex-col items-center text-center gap-4 py-10">
        {ok ? (
          <CheckCircle2 size={44} style={{ color: "var(--yb-mint)" }} />
        ) : (
          <XCircle size={44} style={{ color: "var(--yb-amber)" }} />
        )}
        <Label accent={ok ? "mint" : "amber"}>
          {ok ? "Payment received" : "Checkout cancelled"}
        </Label>
        <h1 className="font-display text-[26px]" style={{ color: "var(--yb-text)" }}>
          {ok ? "Thank you — you're onboard" : "No payment was made"}
        </h1>
        <p className="text-[13px] max-w-md" style={{ color: "var(--yb-text-muted)" }}>
          {ok
            ? "Your payment is being confirmed by Stripe. Once it settles, it appears in the Treasury as real revenue and a supervised onboarding job is queued for the operator to review and send — nothing goes out automatically."
            : "You closed the Stripe checkout before paying. You can head back to the catalog and start again whenever you're ready."}
        </p>
        {ok && sessionId && (
          <div className="font-mono text-[10px] px-3 py-1.5 rounded"
               style={{ color: "var(--yb-text-muted)", border: "1px solid var(--yb-hairline)" }}>
            session: {sessionId}
          </div>
        )}
        <div className="flex gap-2 pt-2">
          <Link to="/catalog"><HudButton variant="ghost">Back to catalog</HudButton></Link>
          {ok && <Link to="/jobs"><HudButton tone="mint">View onboarding queue</HudButton></Link>}
        </div>
      </Panel>

      {ok && (
        <Panel className="flex items-start gap-3">
          <ShieldCheck size={18} style={{ color: "var(--yb-mint)" }} className="shrink-0 mt-0.5" />
          <p className="text-[12px]" style={{ color: "var(--yb-text-muted)" }}>
            Treasury only ever shows money Stripe has actually settled — this confirmation does not
            inflate any balance on its own.
          </p>
        </Panel>
      )}
    </div>
  );
}
